import { TanStackDevtools } from '@tanstack/react-devtools';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { AnyRouter } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

interface TanStackDevtoolsProviderProps {
  router: AnyRouter;
}

export function TanStackDevtoolsProvider({
  router,
}: TanStackDevtoolsProviderProps) {
  return (
    <TanStackDevtools
      config={{
        position: 'bottom-right',
      }}
      plugins={[
        {
          name: 'TanStack Query',
          render: <ReactQueryDevtools />,
          defaultOpen: true,
        },
        {
          name: 'TanStack Router',
          render: <TanStackRouterDevtoolsPanel router={router} />,
          defaultOpen: false,
        },
      ]}
    />
  );
}
